import React from 'react';
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,
  IconButton,
  Chip,
  Typography,
  Box,
  Button,
  Alert
} from '@mui/material';
import {
  Warning as WarningIcon,
  Error as ErrorIcon,
  Info as InfoIcon,
  Check as CheckIcon,

} from '@mui/icons-material';
import { InventoryAlert } from '../types';

interface InventoryAlertsProps {
  alerts: InventoryAlert[];
  onResolve: () => void;
}

export const InventoryAlerts: React.FC<InventoryAlertsProps> = ({ alerts, onResolve }) => {
  const getAlertIcon = (severity: string) => {
    switch (severity) {
      case 'HIGH':
        return <ErrorIcon color="error" />;
      case 'MEDIUM':
        return <WarningIcon color="warning" />;
      default:
        return <InfoIcon color="info" />;
    }
  };

  const getAlertColor = (severity: string): 'error' | 'warning' | 'info' => {
    switch (severity) {
      case 'HIGH':
        return 'error';
      case 'MEDIUM':
        return 'warning';
      default:
        return 'info';
    }
  };

  if (alerts.length === 0) {
    return (
      <Alert severity="success" icon={<CheckIcon />}>
        No active alerts! Your inventory is in good shape.
      </Alert>
    );
  }

  return (
    <Box>
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">Active Alerts ({alerts.length})</Typography>
        <Button variant="outlined" size="small" onClick={onResolve}>
          Refresh
        </Button>
      </Box>
      
      <List>
        {alerts.map((alert) => (
          <ListItem key={alert.AlertID} divider>
            <ListItemIcon>
              {getAlertIcon(alert.Severity)}
            </ListItemIcon>
            <ListItemText
              primary={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="subtitle1">{alert.Product}</Typography>
                  <Chip 
                    label={alert.AlertType.replace('_', ' ')} 
                    size="small" 
                    color={getAlertColor(alert.Severity)}
                  />
                </Box>
              }
              secondary={
                <Box>
                  <Typography variant="body2">{alert.Message}</Typography>
                  <Typography variant="caption" color="textSecondary">
                    SKU: {alert.SKU} • Created: {new Date(alert.CreatedDate).toLocaleDateString()}
                  </Typography>
                </Box>
              }
            />
            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="resolve">
                <CheckIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
